import styled from 'styled-components';
import { kendoPopupZIndex } from 'styles/variables';

export const FullScreenPopupContent = styled.div<{ $noPadding: boolean }>`
    z-index: ${kendoPopupZIndex};
    background: var(--background-paper-elevation-8);
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '2rem')};
`;

export type PopupContentProps = Readonly<{
    $noPadding: boolean;
}>;

export const PopupContentWrapper = styled.div`
    z-index: ${kendoPopupZIndex};
    border-radius: 0.5rem;
    box-shadow: var(--elevation-200);
    position: relative;
`;

export const PopupContent = styled.div<PopupContentProps>`
    border-radius: 0.5rem;
    background: var(--background-paper-elevation-8);
    padding: ${({ $noPadding }) => ($noPadding ? '0' : '2rem')};
    position: relative;
`;
